'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '確認欄と入力が一致していません';